import { useMemo } from 'react';

import { Currency, Table } from '@ui/src';
import { AccountCurrenciesTypes } from './types';
import {
  currenciesColumns,
  currenciesColumnsLabels,
} from '../../../hoc/common/accounts/variables/currencies';
import formatCurrencies from '../../../hoc/common/accounts/helpers/format-currencies';
import { Balance } from '../../../hoc/common/types';

import cn from './styles.module.css';

const AccountCurrencies = ({
  accounts,
  selectedAccount,
  setSelectedAccount,
  currenciesList,
  balances,
  setBlockPopupVisible,
  setSelectedBlockCurrency,
  setEnablePopupVisible,
  setSelectedEnableCurrency,
  status,
  isLoading,
  isFetching,
}: AccountCurrenciesTypes) => {
  const formattedData = useMemo(() => {
    const data = formatCurrencies(
      currenciesList as Currency[],
      balances as Balance[],
      setBlockPopupVisible,
      setSelectedBlockCurrency,
      setEnablePopupVisible,
      setSelectedEnableCurrency,
      status,
    );

    return data;
  }, [currenciesList, balances, status]);

  return (
    <>
      <div className={cn.accountsWrapper}>
        {accounts?.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`${cn.accountButton} ${
              selectedAccount === item.id ? cn.accountButtonActive : ''
            }`}
            onClick={() => setSelectedAccount(item.id)}
          >
            {item.fullNumber}
          </button>
        ))}
      </div>
      <div className={cn.currenciesTableWrapper}>
        <Table
          columns={currenciesColumns}
          data={formattedData || []}
          sort={{}}
          onSort={() => {}}
          filters={{}}
          columnsLabels={currenciesColumnsLabels}
          tableBodyClassName={`${cn.currenciesTable} ${
            isLoading || isFetching ? cn.currenciesTableLoading : ''
          }`}
          onFilterChange={() => {}}
          isLoading={isLoading || isFetching}
        />
      </div>
    </>
  );
};

export default AccountCurrencies;
